module.exports = __webpack_public_path__ + "static/media/teoLogoGrey.ab343a6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teoLogoGrey.png
// module id = 1871
// module chunks = 0